import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
    transform(value: string, replace?: string): string {

        let position = value.indexOf('-');
        if (position == -1)
            position = value.length;

        return value.substring(0, position - 1);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/truncate-text.pipe.ts